import React from "react";
import PropTypes from "prop-types";
import AvatarWithLabel from "views_shared/app/javascript/components/AvatarWithLabel";
import ProfileImage from "./ProfileImage";

// Wires <AvatarWithLabel>'s ringed, curved-label circular avatar into <ProfileImage>'s
// hover-revealed edit controls (upload, delete, saving state, default-image detection) via its
// `renderImage` render-prop. <ProfileImage> stays the single owner of that control logic — this
// component's only job is telling it how to draw the picture underneath, so a person-shaped
// profile (expert, PR, media profile) gets in-place editing without ProfileImage's org-logo look
// leaking onto it, and without a second copy of the control logic.
function AvatarProfileImage({ profileType, size = 160, avatarClassName = "", ...profileImageProps }) {
  return (
    <ProfileImage
      {...profileImageProps}
      renderImage={(imgUrl) => (
        <AvatarWithLabel
          profileType={profileType}
          src={imgUrl}
          alt={profileImageProps.imgOwnerName}
          size={size}
          className={avatarClassName}
          fallbackToInitials
        />
      )}
    />
  );
}

AvatarProfileImage.propTypes = {
  profileType: PropTypes.string.isRequired,
  size: PropTypes.number,
  avatarClassName: PropTypes.string,
};

export default AvatarProfileImage;
